import { BRAND_ICON_SRC } from "@/lib/branding";
import { cn } from "@/lib/utils";

interface BrandMarkProps {
  className?: string;
  imageClassName?: string;
  glow?: boolean;
  glowClassName?: string;
  decorative?: boolean;
}

export function BrandMark({
  className,
  imageClassName,
  glow = false,
  glowClassName,
  decorative = true,
}: BrandMarkProps) {
  return (
    <div className={cn("relative shrink-0", className)}>
      {glow ? (
        <div
          aria-hidden="true"
          className={cn("absolute inset-[12%] rounded-[32%] bg-blue-500/30 blur-xl", glowClassName)}
        />
      ) : null}
      <img
        src={BRAND_ICON_SRC}
        alt={decorative ? "" : "Wenlix"}
        aria-hidden={decorative || undefined}
        draggable={false}
        className={cn("relative h-full w-full select-none object-contain", imageClassName)}
      />
    </div>
  );
}
